module.exports = __webpack_public_path__ + "static/media/osecac.3f480aab.png";